import { FC } from 'react'
import Modal from 'react-modal'
import useModalStore from 'store/modal'
import shallow from 'zustand/shallow'

const CustomModal: FC = ({ children }) => {
  const [isOpen, isSubmit, onRequestClose] = useModalStore((state) => 
  [state.isOpen, state.isSubmit, state.onRequestClose, state.setIsSubmit],
    shallow
  )

  const handleClose = () => {
    if (isSubmit) return;
    onRequestClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        className="mx-auto my-6 overflow-scroll focus:outline-none w-750px"
        onRequestClose={handleClose}
        overlayClassName="bg-gray-900 bg-opacity-70 w-screen h-screen fixed top-0 left-0 bottom-0 right-0 overflow-scroll"
        >
        { isSubmit &&
          <div className="w-screen h-screen fixed z-60 top-0 left-0 bg-black opacity-20" />
        }
        {children}
      </Modal>
      </>
  )
}

export default CustomModal
